(function () {
    function showMeal(block, slug, button) {
        block.querySelectorAll('[data-meal-panel]').forEach((panel) => {
            const isActive = panel.getAttribute('data-meal-panel') === slug;
            panel.hidden = !isActive;
        });

        block.querySelectorAll('.rutina-meals__tab').forEach((tab) => {
            const isActive = tab === button;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
    }

    function initMeals(block) {
        if (!block || block.dataset.mealsReady === '1') {
            return;
        }

        block.dataset.mealsReady = '1';

        const tabs = block.querySelector('.rutina-meals__tabs');

        if (!tabs) {
            return;
        }

        tabs.addEventListener('click', (event) => {
            const button = event.target.closest('.rutina-meals__tab');

            if (!button || !tabs.contains(button)) {
                return;
            }

            const slug = button.getAttribute('data-meal-tab');

            if (!slug) {
                return;
            }

            showMeal(block, slug, button);
        });
    }

    function showAllMealsForPrint() {
        document.querySelectorAll('[data-rutina-meals] [data-meal-panel]').forEach((panel) => {
            panel.hidden = false;
        });
    }

    function boot() {
        document.querySelectorAll('[data-rutina-meals]').forEach(initMeals);
    }

    window.addEventListener('beforeprint', showAllMealsForPrint);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
        boot();
    }
})();
